import { makeAutoObservable, action } from 'mobx';

export default class AppStore {
    // core app store
    spriteMapPath;
    selectorData;
    requestOrganisation;

    // user store
    organisation;
    organisations;
    isAuthenticated;

    // custom temp store
    tutorialDownload = false;

    constructor(initial) {
        makeAutoObservable(this, {
            setTutorialDownload: action,
        });
        // core app store
        this.spriteMapPath = initial.svg_spritemap_path;
        this.requestOrganisation = initial.request_organisation ? initial.request_organisation : null;
        this.selectorData = initial.selector_organisations;

        // user store
        this.organisation = initial.organisation ? initial.organisation : null;
        this.organisations = initial.organisations ? initial.organisations : [];
        this.isAuthenticated = initial.is_authenticated;
    }
    setTutorialDownload = (status) => {this.tutorialDownload = status;}
}
